import axiosInstance from "../axiosInterceptor";

export async function getAllLineSpacing() {
  const response = await axiosInstance.get(
    `admin/lineSpacing/getAllLineSpacing`
  );
  const data = response?.data;
  return data;
}
